import styled from 'styled-components'

export const DropdownMenuCont = styled.div``
